import React from "react";
import { useTranslation } from 'react-i18next';
import NewWindow from "./NewWindow";
import Alert from "./Alert";
import { useDispatch } from "react-redux";
import { clearOrder } from "../actions/orderActions";

export default function ExternalRedirectPaymentFailed(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let { orderResponse, onClose } = props;

    const onCloseWindow = (event) => {
        dispatch(clearOrder());
        if (onClose)
            onClose();
    }

    let  title = t("ThreeDSecureFailed");
    if (props.payByKlarna === true) {
        title = t("KlarnaPaymentFailed");
    }
    else if (props.payByMobilePay === true) {
        title = t("MobilePayPaymentFailed");
    }
    return <NewWindow autoSize={true} title={`${title}`} open={orderResponse.failedExternalRedirectSVerification} onClose={onCloseWindow} closeOnOverlayClick={false}>
        <Alert type="danger" title={t("Checkout")} msg={t("Unable to process your payment. please try again later")} />
    </NewWindow>;

}
